import { ApiOperationItems } from "~enums/apiOperationItems";
import { useApiOperations } from "~hooks/useApiOperations.ts";
import type { UpsertPlacingModel } from "~pages/FinalStandings/types/upsertPlacingModel";
import type { PlacingEntityResponse } from "~types/placingEntity";
import type { PlacingPersonResponse } from "~types/placingPerson";
import { useCreatePlacing } from "./useCreatePlacing.ts";
import { useDeletePlacing } from "./useDeletePlacing.ts";
import { useUpdatePlacing } from "./useUpdatePlacing.ts";

export const useFinalStandingsService = () => {
  const { mutateAsync: createPlacingFn, isPending: isCreatePending } = useCreatePlacing();
  const { mutateAsync: updatePlacingFn, isPending: isUpdatePending } = useUpdatePlacing();
  const { mutateAsync: deletePlacingFn, isPending: isDeletePending } = useDeletePlacing();

  const { create, update, remove } = useApiOperations(ApiOperationItems.FINAL_STANDING);

  const upsertPlacing = async (upsertModel: UpsertPlacingModel): Promise<PlacingEntityResponse | PlacingPersonResponse | undefined> => {
    if (upsertModel.placingId) {
      return update(() => updatePlacingFn(upsertModel));
    }

    return create(() => createPlacingFn(upsertModel));
  };

  const deletePlacing = async (placingId: string) => Boolean(await remove(() => deletePlacingFn(placingId)));

  const isUpsertPending = isCreatePending || isUpdatePending;

  return {
    upsertPlacing,
    isUpsertPending,
    deletePlacing,
    isDeletePending,
  };
};
